// frontend/src/components/MicrosoftLoginButton.js
import React from 'react';
import { Button } from '@mui/material';
import { LogIn } from 'react-feather';
import { useAnalytics } from '../hooks/useAnalytics';

const MicrosoftLoginButton = ({ onLoginError }) => {
  const { trackLogin } = useAnalytics();

  const handleMicrosoftLogin = () => {
    try {
      // Track login attempt (will only record successful attempt if they complete OAuth flow)
      trackLogin();
      // Use original OAuth URL - replace with your backend URL as needed
      window.location.href = `${import.meta.env.VITE_API_URL}/users/oauth/login/`;
    } catch (error) {
      console.error('Microsoft login error:', error);
      if (onLoginError) {
        onLoginError(error);
      }
    }
  };

  return (
    <Button
      variant="contained"
      color="primary"
      startIcon={<LogIn size={20} />}
      fullWidth
      onClick={handleMicrosoftLogin}
      sx={{
        mt: 2,
        '&:focus': {
          outline: '3px solid',
          outlineColor: 'primary.dark',
          outlineOffset: '2px',
        },
      }}
    >
      Login with MyBama
    </Button>
  );
};

export default MicrosoftLoginButton;
